import { combineReducers } from 'redux'

import data from './data/slice'

const dashboardReducer = combineReducers({
  data,
})

export default dashboardReducer
